
import {
  animatedArrow
} from '../../modules/animatedarrows/arrow-helpers';
import jQuery from 'jquery';

export function animatedArrowsInit() {
  // console.log("animatedArrowsInit")

  var $ = $ || jQuery; // added to see solve jquery issue
  var $hoverlink = $(".hoverlink");
  // console.log("$hoverlink", $hoverlink);
  $hoverlink.each(function () {

  //  console.log("each hoverlink")


    var $thisLink = $(this);  

// the svg for the eye icon is not great when using anime.js

    // $thisLink.css("background", "green");
    // this can asl be the hover eye!?

    animatedArrow($thisLink);
    // console.log("end each hoverlink");

  });


  // console.log("end animatedArrowsInit");

} //export default function init()